module.exports = __webpack_public_path__ + "img/29.b7d2192f.webp";